var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      (_vm.$slots.items && _vm.$slots.items.length > _vm.itemsPerPage) ||
      _vm.isCrossSelling
        ? _c("div", { staticClass: "col-12 col-lg-12" }, [
            _c(
              "div",
              {
                ref: "carouselContainer",
                staticClass:
                  "list-item-carousel owl-carousel owl-theme owl-single-item",
              },
              _vm._l(_vm.$slots.items, function (item, index) {
                return _c("slot-component", {
                  key: index,
                  attrs: { vnode: item },
                })
              }),
              1
            ),
          ])
        : _vm._l(_vm.$slots.items, function (item) {
            return _c(
              "div",
              { class: _vm.columnWidths },
              [_c("slot-component", { attrs: { vnode: item } })],
              1
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }